import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminLanguages = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LANGUAGES.GET_ALL, { params });
    return response.data;
};
export const getAdminLanguageById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LANGUAGES.GET_BY_ID(id));
    return response.data;
};
export const createLanguage = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.LANGUAGES.CREATE, data);
    return response.data;
};
export const updateLanguage = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.LANGUAGES.UPDATE(id), data);
    return response.data;
};
export const deleteLanguage = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.LANGUAGES.DELETE(id));
    return response.data;
};

